import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpModule } from '@angular/http';

import { routing, appRoutingProviders }  from './app.routing';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { AppComponent } from './app.component';
import { AuthenticationInterceptor } from './shared/authentication-interceptor';
import { AuthenticationService } from './shared/authentication.service';
import { AuthGuard } from './shared/auth-guard';
import { BondsmanModule } from './bondsman/bondsman.module';
import { CartModule } from './cart/cart.module';
import { CartService } from './cart/cart.service';
import { CaseViewModule } from './case-view/case-view.module';
import { CaseViewService } from './case-view/case-view.service';
import { CivilModule } from './civil/civil.module';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { CountyService } from './shared/county.service';
import { DisclaimerModule } from './disclaimer/disclaimer.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { EventService } from './shared/event.service';
import { getPopoverConfig } from './shared/ciprs-popover-config';
import { HeaderModule } from './header/header.module';
import { JuvenileModule } from './juvenile/juvenile.module';
import { LandingModule } from './landing/landing.module';
import { LoginModule } from './login/login.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule, PopoverConfig } from 'ngx-bootstrap/popover';
import { SessionTimeoutService } from './shared/session-timeout.service';
import { SessionTimeoutWarningModule } from './session-timeout-warning/session-timeout-warning.module';
import { SharedModule } from './shared/shared.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AboutModule } from './about/about.module';
import { HelpModule } from './help/help.module';
import { EmailModule } from './email/email.module';
import { PrintModule } from './print/print.module';
import { ClearHistoryModule } from './clear-history/clear-history.module';
import { JL } from 'jsnlog';
import { ErrorHandler } from '@angular/core';
import { InternalExternalInterceptor } from './shared/internal-external-interceptor';

// To easily generate an Angular exception, use a URL like this: http://localhost:4200/civil/All/blablabla
export class UncaughtExceptionHandler implements ErrorHandler {
  handleError(error: any) {
      JL().fatalException('Uncaught Exception', error);
      console.error(error);
  }
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AlertModule.forRoot(),
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    BondsmanModule,
    BsDatepickerModule.forRoot(),
    BrowserModule,
    CartModule,
    CaseViewModule,
    CivilModule,
    CollapseModule.forRoot(),
    DisclaimerModule,
    FormsModule,
    HeaderModule,
    HttpModule,
    HttpClientModule,
    JuvenileModule,
    LandingModule,
    LoginModule,
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    routing,
    SessionTimeoutWarningModule,
    SharedModule,
    AboutModule,
    HelpModule,
    EmailModule,
    PrintModule,
    ClearHistoryModule
  ],
  providers: [appRoutingProviders,
              AuthenticationInterceptor,
              AuthenticationService,
              CartService,
              CaseViewService,
              CountyService,
              EventService,
              SessionTimeoutService,
              {
                provide: HTTP_INTERCEPTORS,
                useExisting: AuthenticationInterceptor,
                multi: true
              },
              {
                provide: HTTP_INTERCEPTORS,
                useClass: InternalExternalInterceptor,
                multi: true
              },
              { provide: ErrorHandler, useClass: UncaughtExceptionHandler },
              {provide: PopoverConfig, useFactory: getPopoverConfig}],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/app.module.ts